import { ICalltrackingState } from '../../types/reducers/calltracking';

export const defaultState: ICalltrackingState = {
  isAvailable: false,
  isEnabled: false,
  isCompulsory: false,
  period: null,
  incompatibleServices: [],
  calltrackingPhoneSubstitutionsCount: null,
};
